/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useState } from 'react';

import { I18n } from '@coze-arch/i18n';

import { setLangOverride, getLangOverride } from '../../lang-state';

function getCurrentLang(): 'en' | 'th' {
  const override = getLangOverride();
  const lang = override ?? I18n.language;
  return lang.startsWith('th') ? 'th' : 'en';
}

export const LanguageSwitcher = () => {
  const [currentLang, setCurrentLang] = useState<'en' | 'th'>(getCurrentLang);

  const handleToggle = async () => {
    const next = currentLang === 'en' ? 'th' : 'en';
    setCurrentLang(next);
    await setLangOverride(next);
  };

  return (
    <div className="flex items-center justify-center w-[60px] px-[4px]">
      <button
        onClick={handleToggle}
        className="w-[44px] h-[36px] rounded-[8px] text-[14px] font-semibold leading-none border-0 cursor-pointer outline-none transition-colors duration-150 coz-mg-primary coz-fg-plus hover:coz-mg-primary-hovered"
      >
        {currentLang === 'en' ? 'EN' : 'TH'}
      </button>
    </div>
  );
};
